import { ReactNode } from 'react';
import styled from '@emotion/styled';

import {
  spacing,
  borderRadius,
  fontSize,
  mediaMaxWithLayoutTheme,
} from 'presentations/views/styles';
import {
  gray01,
  gray02,
  gray03,
  gray05,
} from 'presentations/views/styles/color';
import Icon from 'presentations/views/components/atoms/Icon';
import { css } from '@emotion/react';

interface Props {
  onClick?: any;
  children: ReactNode;
  className?: string;
  isDisabled?: boolean;
}

export default function Component(props: Props) {
  return (
    <AddButton
      className={props.className}
      role="button"
      onClick={props.isDisabled ? null : props.onClick}
      isDisabled={props.isDisabled}
    >
      <StyledIcon isDisabled={props.isDisabled} name="add" />
      <Name isDisabled={props.isDisabled}>{props.children}</Name>
    </AddButton>
  );
}

const Name = styled.span<{
  isDisabled?: boolean;
}>`
  margin-left: ${spacing(4)};
  color: ${gray01};
  ${(props) =>
    props.isDisabled &&
    `
    color: ${gray03(props)};
  `}
`;
const StyledIcon = styled(Icon)<{
  isDisabled?: boolean;
}>`
  font-size: ${fontSize(14)};
  color: ${gray01};
  ${(props) =>
    props.isDisabled &&
    `
    color: ${gray03(props)};
  `}
`;
const AddButton = styled.div<{
  isDisabled?: boolean;
}>`
  cursor: pointer;
  padding: ${spacing(12)} ${spacing(16)};
  border: 1px dashed ${gray03};
  border-radius: ${borderRadius(6)};
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) =>
    !props.isDisabled &&
    css`
      &:hover {
        border: 1px dashed ${gray02(props)};
        background: ${gray05(props)};
      }
    `}

  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    padding: ${spacing(8)} ${spacing(16)};
    font-size: ${fontSize(12)};
  }

  cursor: ${(props) => props.isDisabled && 'not-allowed'};
`;
